const axios = require("axios");

// 上述请求也可以按以下方式完成（可选）
axios
  .get("https://zombies.telgather.com/platform/newPlants/callback/website", {
    params: {},
  })
  .then(function (response) {
    console.log(response);
  })
  .catch(function (error) {
    console.log(error);
  })
  .finally(function () {
    // 总是会执行
  });

// 支持async/await用法
export async function getInfo() {
  try {
    const response = await axios.get(
      "https://zombies.telgather.com/platform/newPlants/callback/website"
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export default axios;
